import { render } from "./digitalInfoSetting.vue?vue&type=template&id=6aca4ace&scoped=true&ts=true"
import script from "./digitalInfoSetting.vue?vue&type=script&lang=ts"
export * from "./digitalInfoSetting.vue?vue&type=script&lang=ts"

import "./digitalInfoSetting.vue?vue&type=style&index=0&id=6aca4ace&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aca4ace"]])

export default __exports__